import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Link, useNavigate, useParams } from "react-router-dom";
import { IoIosArrowForward } from "react-icons/io";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Rating from "../components/Rating";
import { FaHeart } from "react-icons/fa6";
import { FaFacebookF } from "react-icons/fa";
import Reviews from "../components/Reviews";
import "swiper/css";
import "swiper/css/pagination";
import { useDispatch, useSelector } from "react-redux";
import { product_details } from "../store/reducers/homeReducer";
import toast from "react-hot-toast";
import {
  add_to_card,
  messageClear,
  add_to_wishlist,
} from "../store/reducers/cardReducer";
import CurrencyFormat from "../components/shared/CurrencyFormat";

const Details = () => {
  const navigate = useNavigate();
  const { slug } = useParams();
  const dispatch = useDispatch();

  const { product, moreProducts } = useSelector((state) => state.home);
  const { totalReview } = useSelector((state) => state.home);
  const { userInfo } = useSelector((state) => state.auth);
  const { errorMessage, successMessage } = useSelector((state) => state.card);

  const [image, setImage] = useState("");
  const [state, setState] = useState("reviews");
  const [quantity, setQuantity] = useState(1);

  // Carousel responsive configuration
  const responsive = {
    superLargeDesktop: { breakpoint: { max: 4000, min: 3000 }, items: 5 },
    desktop: { breakpoint: { max: 3000, min: 1024 }, items: 5 },
    tablet: { breakpoint: { max: 1024, min: 764 }, items: 4 },
    mdtablet: { breakpoint: { max: 991, min: 464 }, items: 4 },
    mobile: { breakpoint: { max: 764, min: 0 }, items: 3 },
    smmobile: { breakpoint: { max: 640, min: 0 }, items: 3 },
    xsmobile: { breakpoint: { max: 440, min: 0 }, items: 2 },
  };

  useEffect(() => {
    dispatch(product_details(slug));
    window.scrollTo(0, 0);
  }, [slug, dispatch]);

  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage);
      dispatch(messageClear());
    }
    if (errorMessage) {
      toast.error(errorMessage);
      dispatch(messageClear());
    }
  }, [successMessage, errorMessage, dispatch]);

  const inc = () => {
    if (quantity >= product.stock) {
      toast.error("Fuera de Inventario");
    } else {
      setQuantity(quantity + 1);
    }
  };

  const dec = () => {
    if (quantity > 1) {
      setQuantity(quantity - 1);
    }
  };

  const add_card = () => {
    if (!userInfo) {
      navigate("/login");
      return;
    }
    dispatch(
      add_to_card({
        userId: userInfo.id,
        quantity,
        productId: product._id,
      })
    );
  };

  const add_wishlist = () => {
    if (!userInfo) {
      navigate("/login");
      return;
    }
    dispatch(
      add_to_wishlist({
        userId: userInfo.id,
        productId: product._id,
        name: product.name,
        price: product.price,
        image: product.images[0],
        discount: product.discount,
        rating: product.rating,
        slug: product.slug,
      })
    );
  };

  const buynow = () => {
    if (!userInfo) {
      navigate("/login");
      return;
    }

    const price =
      product.discount !== 0
        ? product.price - Math.floor((product.price * product.discount) / 100)
        : product.price;

    const obj = [
      {
        sellerId: product.sellerId,
        shopName: product.shopName,
        price: quantity * (price - Math.floor((price * 5) / 100)),
        products: [
          {
            quantity,
            productInfo: product,
          },
        ],
      },
    ];

    navigate("/shipping", {
      state: {
        products: obj,
        price: price * quantity,
        shipping_fee: 0,
        items: 1,
      },
    });
  };

  return (
    <div className="flex flex-col min-h-screen">
      <Header />

      {/* Hero Banner */}
      <section className='bg-[url("https://diarcel.com/images/banner/shop.png")] h-[220px] bg-cover bg-no-repeat relative bg-left'>
        <div className="absolute inset-0 bg-[#2422228a]">
          <div className="container mx-auto px-4 h-full">
            <div className="flex flex-col justify-center items-center h-full text-white">
              <h2 className="text-3xl font-bold mb-2">Detalles del Producto</h2>
              <div className="flex items-center gap-2 text-lg">
                <Link to="/" className="hover:text-green-400">
                  Inicio
                </Link>
                <IoIosArrowForward />
                <span>Ver Producto</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Breadcrumb */}
      <div className="bg-slate-100 py-4">
        <div className="container mx-auto px-4">
          <div className="flex items-center text-slate-600 text-sm">
            <Link to="/" className="hover:text-green-600">
              Inicio
            </Link>
            <IoIosArrowForward className="mx-2" />
            <Link
              to={`/products?category=${product.category}`}
              className="hover:text-green-600"
            >
              {product.category}
            </Link>
            <IoIosArrowForward className="mx-2" />
            <span className="truncate">{product.name}</span>
          </div>
        </div>
      </div>

      {/* Product Details */}
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Product Images */}
          <div className="space-y-4">
            <div className="aspect-square rounded-lg overflow-hidden bg-white flex items-center justify-center">
              <img
                className="object-contain max-h-full w-auto"
                src={image || product.images?.[0]}
                alt={product.name}
              />
            </div>

            <div className="h-24">
              {product.images && (
                <Carousel
                  autoPlay={true}
                  infinite={true}
                  responsive={responsive}
                  transitionDuration={500}
                  className="py-2"
                >
                  {product.images.map((img, i) => (
                    <div
                      key={i}
                      onClick={() => setImage(img)}
                      className="h-20 w-20 mx-1 rounded-lg overflow-hidden cursor-pointer"
                    >
                      <img
                        className="h-full w-full object-cover"
                        src={img}
                        alt=""
                      />
                    </div>
                  ))}
                </Carousel>
              )}
            </div>
          </div>

          {/* Product Info */}
          <div className="space-y-6">
            <h1 className="text-3xl font-bold text-slate-800">
              {product.name}
            </h1>

            <div className="flex items-center gap-1 text-xl">
              <Rating ratings={product.rating} />
              <span className="text-green-500">
                ({totalReview} reseña{totalReview === 1 ? "" : "s"})
              </span>
            </div>

            {/* Price */}
            <div className="space-y-2">
              {product.discount ? (
                <>
                  <p className="text-lg text-slate-600">Precio</p>
                  <div className="space-y-1">
                    <CurrencyFormat
                      className="text-xl text-slate-400 line-through"
                      value={product.price}
                    />
                    <div className="flex items-center gap-2">
                      <CurrencyFormat
                        className="text-2xl font-bold text-slate-800"
                        value={
                          product.price -
                          Math.floor((product.price * product.discount) / 100)
                        }
                      />
                      <span className="text-red-500">
                        (-{product.discount}%)
                      </span>
                    </div>
                  </div>
                </>
              ) : (
                <div className="space-y-1">
                  <p className="text-lg text-slate-600">Precio</p>
                  <CurrencyFormat
                    className="text-2xl font-bold text-slate-800"
                    value={product.price}
                  />
                </div>
              )}
            </div>

            {/* Description */}
            <div className="space-y-2">
              <h3 className="font-semibold text-slate-800">Descripción</h3>
              <p className="text-slate-600 whitespace-pre-line">
                {product.description}
              </p>
            </div>

            {/* Store */}
            <div className="space-y-2">
              <h3 className="font-semibold text-slate-800">Tienda</h3>
              <p className="text-slate-600">{product.shopName}</p>
            </div>

            {/* Actions */}
            {product.stock ? (
              <div className="flex flex-wrap gap-4">
                <div className="flex items-center bg-slate-100 rounded-lg">
                  <button
                    onClick={dec}
                    className="p-3 hover:bg-slate-200 rounded-l-lg transition"
                  >
                    -
                  </button>
                  <span className="px-6 py-3">{quantity}</span>
                  <button
                    onClick={inc}
                    className="p-3 hover:bg-slate-200 rounded-r-lg transition"
                  >
                    +
                  </button>
                </div>

                <button
                  onClick={add_card}
                  className="px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition"
                >
                  Agregar al Carrito
                </button>

                <button
                  onClick={add_wishlist}
                  className="p-3 bg-cyan-500 text-white rounded-full hover:bg-cyan-600 transition"
                >
                  <FaHeart />
                </button>
              </div>
            ) : null}

            {/* Additional Info */}
            <div className="space-y-4 pt-4 border-t">
              <div className="flex gap-4">
                <span className="font-semibold text-slate-800">
                  Disponibilidad:
                </span>
                <span className={`text-${product.stock ? "green" : "red"}-500`}>
                  {product.stock
                    ? `Disponible(${product.stock})`
                    : "Fuera de Inventario"}
                </span>
              </div>

              <div className="flex gap-4">
                <span className="font-semibold text-slate-800">
                  Compartir en:
                </span>
                <a
                  href="https://www.facebook.com/profile.php?id=100063564433097"
                  className="p-2 bg-indigo-500 text-white rounded-full hover:bg-indigo-600 transition"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaFacebookF />
                </a>
              </div>
            </div>

            {/* Buy Now & Support */}
            <div className="flex flex-wrap gap-4">
              {product.stock ? (
                <button
                  onClick={buynow}
                  className="px-6 py-3 bg-green-700 text-white rounded-lg hover:bg-green-800 transition"
                >
                  Comprar Ahora
                </button>
              ) : null}

              <Link
                to={`/dashboard/chat/${product.sellerId}`}
                className="px-6 py-3 bg-red-500 text-white rounded-lg hover:bg-red-600 transition"
              >
                Chat de Soporte
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Reviews & Description */}
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
          <div className="lg:col-span-8">
            <div className="bg-white rounded-lg shadow">
              <div className="grid grid-cols-2">
                <button
                  onClick={() => setState("reviews")}
                  className={`py-3 px-5 transition ${
                    state === "reviews"
                      ? "bg-green-600 text-white"
                      : "bg-slate-100 text-slate-700 hover:bg-green-50"
                  } rounded-tl-lg`}
                >
                  Reseñas
                </button>
                <button
                  onClick={() => setState("description")}
                  className={`py-3 px-5 transition ${
                    state === "description"
                      ? "bg-green-600 text-white"
                      : "bg-slate-100 text-slate-700 hover:bg-green-50"
                  } rounded-tr-lg`}
                >
                  Descripción
                </button>
              </div>

              <div className="p-6">
                {state === "reviews" ? (
                  <Reviews product={product} />
                ) : (
                  <p className="text-slate-600 whitespace-pre-line">
                    {product.description}
                  </p>
                )}
              </div>
            </div>
          </div>

          {/* More from Store */}
          <div className="lg:col-span-4">
            <div className="bg-white rounded-lg shadow">
              <div className="p-4 bg-slate-100 rounded-t-lg">
                <h2 className="font-bold text-slate-800">
                  Más de {product.shopName}
                </h2>
              </div>

              <div className="p-4 space-y-4">
                {moreProducts.map((p, i) => (
                  <Link
                    key={i}
                    to={`/product/${p.slug}`}
                    className="block group"
                  >
                    <div className="aspect-square relative overflow-hidden rounded-lg">
                      <img
                        className="w-full h-full object-cover group-hover:scale-105 transition duration-300 cursor-pointer"
                        src={p.images[0]}
                        alt={p.name}
                      />
                      {p.discount > 0 && (
                        <div className="absolute top-2 left-2 w-10 h-10 bg-green-600 text-white rounded-full flex items-center justify-center text-sm font-semibold">
                          {p.discount}%
                        </div>
                      )}
                    </div>
                    <div className="mt-2 space-y-1">
                      <h3 className="font-semibold text-slate-800 group-hover:text-green-600 transition">
                        {p.name}
                      </h3>
                      <div className="flex items-center justify-between">
                        <CurrencyFormat
                          className="text-lg font-bold text-slate-800"
                          value={p.price}
                        />
                        <div className="flex justify-start">
                          <Rating ratings={p.rating} />
                        </div>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Details;
